import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '@core/services';

@Pipe({
  name: 'filtersListLink'
})
export class FilterListLinkPipe implements PipeTransform {

  constructor(
    private readonly localizationService: LocalizationService
  ) {}

  transform(name: string): string {
    return this.localizationService.getRouterLinkApp('list/' + name.toLowerCase());
  }

}
